export function isOffline() {
    return Boolean(window.xy_is_offline);
}
export function addJsonPrefixIfOffline() {
    return isOffline() ? '.json' : '';
}
